/**
 * Fields the plan cannot be generated without.
 * Kept in one place so the Basics banner, the Next button, the stepper and the
 * Review step all agree on what is "must have".
 */
const hhmm = (v) => (/^\d{2}:\d{2}$/.test(String(v || "")) ? String(v) : "");
const mins = (v) => {
  const s = hhmm(v);
  return s ? Number(s.slice(0, 2)) * 60 + Number(s.slice(3)) : null;
};

export function getRequiredIssues({
  hasProblem = false,
  isMultiTeam = false,
  memberNames = [],
  teamOn = true,
  timingOn = true,
  numDays = 0,
  dailyStart = "",
  dailyEnd = "",
} = {}) {
  const issues = [];

  issues.push({
    id: "problem",
    page: "problem",
    label: "Problem statement",
    ok: !!hasProblem,
    detail: isMultiTeam
      ? "Problem statement: map one to every team"
      : "Problem statement: enter or generate one",
  });

  if (teamOn && !isMultiTeam) {
    const named = (memberNames || []).filter((n) => String(n || "").trim()).length;
    issues.push({
      id: "member",
      page: "basics",
      label: "Your name (at least one member)",
      ok: named >= 1,
      detail: "Basics → Members: add at least one member name",
    });
  }

  if (timingOn) {
    const days = Number(numDays);
    issues.push({
      id: "days",
      page: "basics",
      label: "Number of working days",
      ok: Number.isFinite(days) && days >= 1,
      detail: "Basics → Timing: set the number of working days (1 or more)",
    });
    const a = mins(dailyStart);
    const b = mins(dailyEnd);
    issues.push({
      id: "window",
      page: "basics",
      label: "Daily start and end time",
      ok: a != null && b != null && b > a,
      detail: "Basics → Timing: set a daily start time that is before the end time",
    });
  }
  return issues;
}

export const missingIssues = (issues) => (issues || []).filter((i) => !i.ok);
export const missingOnPage = (issues, page) => missingIssues(issues).filter((i) => i.page === page);
